export const NEW_PHYSICAL_THERAPIST_CONSTANT = [
//   {
//     sectionHeading: 'Note Type',
//     rowNumber: 1,
//   },
//   {
//     noteType: true,
//     isTemplate: false,
//     rowNumber: 2,
//     isEntry: false,
//     isFullForm: true,
//     isEdit: false
//   },
    { sectionHeading: 'Patient Information', rowNumber: 3 },
    {
        label: 'Client',
        name: 'clientId',
        type: 'searchableSelect',
        options: [],
        disabled: false,
        required: true,
        rowNumber: 4,
      },
    {
        sectionHeading: 'Emergency Contact Information',
        rowNumber: 7
    },
    {
        label: 'Name',
        name: 'emergencyContactName',
        type: 'text',
        required: true,
        rowNumber: 8,
    },
    {
        label: 'Relationship',
        name: 'relationship',
        type: 'text',
        // required: true,
        rowNumber: 8,
    },
    {
        label: 'Phone Number',
        name: 'phoneNumber',
        type: 'phoneNumber',
        // required: true,
        rowNumber: 8,
    },
    {
        label: 'Name',
        name: 'emergencyContactName1',
        type: 'text',
        required: false,
        rowNumber: 9,
    },
    {
        label: 'Relationship',
        name: 'relationship1',
        type: 'text',
        required: false,
        rowNumber: 9,
    },
    {
        label: 'Phone Number',
        name: 'phoneNumber1',
        type: 'phoneNumber',
        required: false,
        rowNumber: 9,
    },
    {
        sectionHeading: 'Referring Provider ',
        rowNumber: 10
    },
    {
        label: 'Name',
        name: 'referringProviderName',
        type: 'text',
        // required: true,
        rowNumber: 11,
    },
    {
        label: 'Phone Number',
        name: 'referringProviderPhoneNumber',
        type: 'phoneNumber',
        // required: true,
        rowNumber: 11,
    },
    {
        sectionHeading: 'Primary Care Provider',
        rowNumber: 12
    },
    {
        label: 'Name',
        name: 'primaryCareProviderName',
        type: 'text',
        // required: true,
        rowNumber: 13,
    },
    {
        label: 'Phone Number',
        name: 'primaryCareProviderPhoneNumber',
        type: 'phoneNumber',
        // required: true,
        rowNumber: 13,
    },
    {
        type: 'sectionTitle',
        title: 'Pain Assessment',
        rowNumber: 17
    },
    {
        type: 'PhysicalTherapistDialog',
        rowNumber: 17,
        isDisabled: false
    },
    {
        sectionHeading: 'Medical Issues (Check all that apply)',
        rowNumber: 18
    },
    {
        label: '',
        name: 'desease',
        type: 'checkbox',
        options: [
            { label: 'AIDS / HIV', value: 'AIDS / HIV' },
            { label: 'ANEMIA', value: 'ANEMIA' },
            { label: 'ANGINA', value: 'ANGINA' },
            { label: 'ARTERIORSCLEROSIS', value: 'ARTERIORSCLEROSIS' },
            { label: 'ARTHRITIS', value: 'ARTHRITIS' },
            { label: 'ASTHMA', value: 'ASTHMA' },
            { label: 'BLOOD CLOTS', value: 'BLOOD CLOTS' },
            { label: 'CANCER', value: 'CANCER' },
            { label: 'CHEMICAL DEPENDENCY', value: 'CHEMICAL DEPENDENCY' },
            { label: 'CIRCULATION PROBLEMS', value: 'CIRCULATION PROBLEMS' },
            { label: 'DEPRESSION', value: 'DEPRESSION' },
            { label: 'DIABETES', value: 'DIABETES' },
            { label: 'EPILEPSY / SEIZURES', value: 'EPILEPSY / SEIZURES' },
            { label: 'EYE INFECTION', value: 'EYE INFECTION' },
            { label: 'HEART PROBLEMS', value: 'HEART PROBLEMS' },
            { label: 'HEMOPHELIA', value: 'HEMOPHELIA' },
            { label: 'HIGH OR LOW BLOOD PRESSURE', value: 'HIGH OR LOW BLOOD PRESSURE' },
            { label: 'JOINT PAIN OR INFLAMMATION', value: 'JOINT PAIN OR INFLAMMATION' },
            { label: 'LIVER PROBLEMS', value: 'LIVER PROBLEMS' },
            { label: 'LUNG DISEASE', value: 'LUNG DISEASE' },
            { label: 'MULTIPLE SCLEROSIS', value: 'MULTIPLE SCLEROSIS' },
            { label: 'NEUROLOGICAL DISEASE', value: 'NEUROLOGICAL DISEASE' },
            { label: 'OSTEOPOROSIS', value: 'OSTEOPOROSIS' },
            { label: 'SCOLIOSIS', value: 'SCOLIOSIS' },
            { label: 'SPASMS OR CRAMPS', value: 'SPASMS OR CRAMPS' },
            { label: 'STROKE', value: 'STROKE' },
            { label: 'TUBERCULOSIS', value: 'TUBERCULOSIS' },
            { label: 'URINARY', value: 'URINARY' },
        ],
        // required: true,
        rowNumber: 18,
    },
    {
        sectionHeading: 'Goals and Objectives',
        rowNumber: 19
    },
    {
        sectionHeading: 'Patient Goals',
        rowNumber: 20
    },
    {
        label: 'What do you hope to achieve from Physical Therapy? Patient Goals',
        name: 'patientGoals',
        type: 'textarea',
        // required: true,
        rowNumber: 21,
        minRows: 3,
    },
    {
        sectionHeading: 'Patient Concerns',
        rowNumber: 22
    },
    {
        label: 'Do you have any conserns or worries going into therapy?',
        name: 'concernsOrWorry',
        type: 'textarea',
        // required: true,
        rowNumber: 23,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'Plan of Care - Physical Therapy',
        rowNumber: 24
    },
    {
        sectionHeading: 'Referring Physician',
        rowNumber: 28
    },
    {
        label: 'Name',
        name: 'referringPhysicianName',
        type: 'text',
        // required: true,
        rowNumber: 29,
    },
    {
        label: 'Phone Number',
        name: 'referringPhysicianPhoneNumber',
        type: 'phoneNumber',
        // required: true,
        rowNumber: 29,
    },
    {
        label: 'Plan of Care Date',
        name: 'planOfCareDate',
        type: 'date',
        // required: true,
        rowNumber: 30,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Date of Onset',
        name: 'dateOfOnset',
        type: 'date',
        // required: true,
        rowNumber: 30,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Date of Evaluation',
        name: 'dateOfEvaluation',
        type: 'date',
        // required: true,
        rowNumber: 30,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Summary of Evaluation Findings',
        name: 'summaryOfEvaluationFindings',
        type: 'textarea',
        // required: true,
        rowNumber: 31,
        minRows: 3,
    },
    {
        sectionHeading: 'Diagnosis',
        rowNumber: 32
    },
    {
        label: 'Treatment Diagnosis',
        name: 'treatmentDiagnosis',
        type: 'textarea',
        // required: true,
        rowNumber: 33,
        minRows: 3,
    },
    {
        label: 'Medical Diagnosis',
        name: 'medicalDiagnosis',
        type: 'textarea',
        // required: true,
        rowNumber: 34,
        minRows: 3,
    },
    {
        sectionHeading: 'Treatment Goals',
        rowNumber: 35
    },
    {
        label: 'Short-Term Goals',
        name: 'shortTermGoals',
        type: 'textarea',
        // required: true,
        rowNumber: 36,
        minRows: 3,
    },
    {
        label: 'Long-Term Goals',
        name: 'longTermGoals',
        type: 'textarea',
        // required: true,
        rowNumber: 37,
        minRows: 3,
    },
    {
        sectionHeading: 'Treatment Plan(Type / Amount / Duration)',
        rowNumber: 39
    },
    {
        label: 'Type / Amount / Duration',
        name: 'planOfCareTreatmentPlan',
        type: 'textarea',
        // required: true,
        rowNumber: 40,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'SOAP Progress Note - Physical Therapy',
        rowNumber: 41
    },
    // {
    //     label: 'Date',
    //     name: 'progressNoteDate',
    //     type: 'date',
    //     required: true,
    //     rowNumber: 42,
    // },
    // {
    //     type: 'WoundDialog',
    //     rowNumber: 45
    // },
    // {
    //     sectionHeading: 'Subjective',
    //     rowNumber: 46
    // },
    {
        label: 'Subjective',
        name: 'subjective',
        type: 'textarea',
        // required: true,
        rowNumber: 46,
        minRows: 3,
    },
    // {
    //     sectionHeading: 'Objective',
    //     rowNumber: 47
    // },
    {
        label: 'Objective',
        name: 'objective',
        type: 'textarea',
        // required: true,
        rowNumber: 48,
        minRows: 3,
    },
    // {
    //     sectionHeading: 'Assessment',
    //     rowNumber: 49
    // },
    {
        label: 'Assessment',
        name: 'assessment',
        type: 'textarea',
        // required: true,
        rowNumber: 50,
        minRows: 3,
    },
    // {
    //     sectionHeading: 'Treatment Plan',
    //     rowNumber: 51
    // },
    {
        label: 'Treatment Plan',
        name: 'treatmentPlan',
        type: 'textarea',
        // required: true,
        rowNumber: 52,
        minRows: 3,
    },
    // {
    //     sectionHeading: 'Additional Notes',
    //     rowNumber: 53
    // },
    {
        label: 'Injury Date ',
        name: 'dateOfInjury',
        type: 'date',
        // required: true,
        rowNumber: 55,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Modality Type',
        name: 'modalityType',
        type: 'text',
        // required: true,
        rowNumber: 55,
    },
    // {
    //     sectionHeading: 'Current Medications',
    //     rowNumber: 56
    // },
    {
        label: 'Current Medications',
        name: 'currentMedications',
        type: 'textarea',
        // required: true,
        rowNumber: 57,
        minRows: 3,
    },
    {
        sectionHeading: 'Next Session(s)',
        rowNumber: 58
    },
    {
        label: 'Date',
        name: 'nextSessionDate',
        type: 'date',
        // required: true,
        rowNumber: 58,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 1))
    },
    {
        type: 'sectionTitle',
        title: 'Narrative Note - Physical Therapy',
        rowNumber: 60
    },
    {
        label: 'Narrative Information',
        name: 'narrativeInformation',
        type: 'smartTextarea',
        // required: true,
        rowNumber: 60,
        minRows: 5,
    }
]

export const PHYSICAL_THERAPIST_CONSTANT_DATA = {
    assessmentId: '',
    therapyDate: '',
    noteType: '',
    startDate: '',
    endDate: '',
    clientId: '',
    timeIn: '',
    timeOut: '',
    displayDateRange: '',
    emergencyContactName: '',
    relationship: '',
    phoneNumber: '',
    emergencyContactName1: '',
    relationship1: '',
    phoneNumber1: '',
    referringProviderName: '',
    referringProviderPhoneNumber: '',
    primaryCareProviderName: '',
    primaryCareProviderPhoneNumber: '',
    insurance: '',
    insurancePolicyNumber: '',
    insuranceProvider: '',  
    // insurerBirthDate: '',
    planOfCareTreatmentPlan: '',
    subjective: '',
    objective: '',
    assessment: '',
    treatmentPlan: '',
    insuranceIdNumber: '',
    dateOfInjury: '',
    modalityType: '',
    currentMedications: '',
    nextSessionDate: '',
    nextSessionTime: '',    
    narrativeInformation: '',
    ratePain: '',
    typeOfPain: '',
    howOftenPain: '',
    relievePain: '',
    addrInfo: {
        primaryPhone: "",
        country: "",
        st1: "",
        st2: "",
        city: "",
        state: "",
        zipCode: "",
        accuracy: 90, 
        lat: 0,
        lng: 0,
    },

}

export const PHYSICAL_ASSESSMENT_CONSTANT_1 = [
    {
        sectionHeading: 'Select Client',
        rowNumber: 55
    },
    {
        label: 'Client',
        name: 'clientId',
        type: 'searchableSelect',
        options: [],
        disabled: false,
        required: true,
        rowNumber: 56,
    },
    {
        label: 'Assessment Date',
        name: 'assessmentDate',
        type: 'date',
        required: true,
        rowNumber: 56,
      },
    {
        sectionHeading: 'Physical Assessment',
        rowNumber: 61
    },
    {
        label: 'Diagnosis',
        name: 'diagnosis',
        type: 'textarea',
        required: false,
        rowNumber: 63,
        minRows: 2,
    },
    {
        label: 'Onset',
        name: 'onset',
        type: 'textarea',
        required: false,
        rowNumber: 64,
        minRows: 2,
    },
    {
        label: 'Precautions',
        name: 'precautions',
        type: 'textarea',
        required: false,
        rowNumber: 65,
        minRows: 2,
    },
    {
        sectionHeading: 'Prior Level of Function',
        rowNumber: 66
    },
    {
        label: 'Subjective',
        name: 'subjective',
        type: 'textarea',
        required: false,
        rowNumber: 67,
        minRows: 2,
    },
    {
        label: 'Indoor Mobility',
        name: 'indoorMobility',
        type: 'select',
        options: [
            { label: 'Independent', value: 'Independent' },
            { label: 'Needed Some Help', value: 'Needed Some Help' },
            { label: 'Dependent', value: 'Dependent' },
            { label: 'Unknown', value: 'Unknown' },
            { label: 'Not Applicable', value: 'Not Applicable' },
        ],
        required: false,
        rowNumber: 68,
    },
    {
        label: 'Stairs',
        name: 'stairs',
        type: 'select',
        options: [
            { label: 'Independent', value: 'Independent' },
            { label: 'Needed Some Help', value: 'Needed Some Help' },
            { label: 'Dependent', value: 'Dependent' },
            { label: 'Unknown', value: 'Unknown' },
            { label: 'Not Applicable', value: 'Not Applicable' },
        ],
        required: false,
        rowNumber: 68,
    },
    {
        sectionHeading: 'Prior Device Use',
        rowNumber: 70
    },
    {
        name: 'priorDeviceUse',
        type: 'checkbox',
        options: [
            { label: 'Manual wheelchair', value: 'Manual wheelchair' },
            { label: 'Motorized wheelchair or scooter', value: 'Motorized wheelchair or scooter' },
            { label: 'Mechanical lift', value: 'Mechanical lift' },
            { label: 'Walker', value: 'Walker' },
            { label: 'Orthotics/Prosthetics', value: 'Orthotics/Prosthetics' },
            { label: 'None of the above', value: 'None of the above' },
        ],
        required: false,
        rowNumber: 71,
    },
]

export const PHYSICAL_ASSESSMENT_CONSTANT_2 = [
    {
        sectionHeading: 'Patient Evaluation',
        rowNumber: 78
    },
    {
        label: 'Gait Deviations',
        name: 'gaitDeviations',
        type: 'textarea',
        required: false,
        rowNumber: 79,
        minRows: 2,
    },
    {
        label: 'Movement Patterns',
        name: 'movementPatterns',
        type: 'textarea',
        required: false,
        rowNumber: 80,
        minRows: 2,
    },
    {
        label: 'Other',
        name: 'other',
        type: 'textarea',
        required: false,
        rowNumber: 81,
        minRows: 2,
    },
    {
        sectionHeading: 'Sensation',
        rowNumber: 82
    },
    {
        label: 'Light Touch',
        name: 'lightTouch',
        type: 'select',
        options: [
            { label: 'Intact (I)', value: 'I' },
            { label: 'Decreased (D)', value: 'D' }
        ],
        required: false,
        rowNumber: 83,
    },
    {
        label: 'Sharp/Dull',
        name: 'sharpDull',
        type: 'select',
        options: [
            { label: 'Intact (I)', value: 'I' },
            { label: 'Decreased (D)', value: 'D' }
        ],
        required: false,
        rowNumber: 83,
    },
    {
        label: 'Deep Touch',
        name: 'deepTouch',
        type: 'select',
        options: [
            { label: 'Intact (I)', value: 'I' },
            { label: 'Decreased (D)', value: 'D' }
        ],
        required: false,
        rowNumber: 83,
    },
    {
        label: 'Hot/Cold',
        name: 'hotCold',
        type: 'select',
        options: [
            { label: 'Intact (I)', value: 'I' },
            { label: 'Decreased (D)', value: 'D' }
        ],
        required: false,
        rowNumber: 84,
    },
    {
        label: 'Kinesthesia',
        name: 'kinesthesia',
        type: 'select',
        options: [
            { label: 'Intact (I)', value: 'I' },
            { label: 'Decreased (D)', value: 'D' }
        ],
        required: false,
        rowNumber: 84,
    },
    {
        label: 'Proprioception',
        name: 'proprioception',
        type: 'select',
        options: [
            { label: 'Intact (I)', value: 'I' },
            { label: 'Decreased (D)', value: 'D' }
        ],
        required: false,
        rowNumber: 84,
    },
    {
        sectionHeading: 'Reflexes',
        rowNumber: 89
    },
    {
        label: 'DTR (Deep Tendon Reflexes)',
        name: 'dtr',
        type: 'select',
        options: [
            { label: 'Present (+)', value: '+' },
            { label: 'Absent (-)', value: '-' }
        ],
        required: false,
        rowNumber: 90,
    },
    {
        label: 'Clonus',
        name: 'clonus',
        type: 'select',
        options: [
            { label: 'Present (+)', value: '+' },
            { label: 'Absent (-)', value: '-' }
        ],
        required: false,
        rowNumber: 90,
    },
    {
        label: 'Babinski',
        name: 'babinski',
        type: 'select',
        options: [
            { label: 'Present (+)', value: '+' },
            { label: 'Absent (-)', value: '-' }
        ],
        required: false,
        rowNumber: 90,
    },
    {
        sectionHeading: 'Range of Motion',
        rowNumber: 91
    },
    {
        label: 'ROM Status',
        name: 'romStatus',
        type: 'select',
        options: [
            { label: 'BFL - Beyond Full Length', value: 'BFL' },
            { label: 'WFL - Within Full Length', value: 'WFL' }
        ],
        required: false,
        rowNumber: 92,
    },
    {
        sectionHeading: 'Hip Flexion',
        rowNumber: 93
    },
    {
        name: 'hipFlexion',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 94,
    },
    {
        sectionHeading: 'Hip Extension',
        rowNumber: 95
    },
    {
        name: 'hipExtension',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 96,
    },
    {
        sectionHeading: 'Hip Abduction',
        rowNumber: 97
    },
    {
        name: 'hipAbduction',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 98,
    },
    {
        sectionHeading: 'Hip Adduction',
        rowNumber: 99
    },
    {
        name: 'hipAdduction',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 100,
    },
    {
        sectionHeading: 'Hip Internal Rotation',
        rowNumber: 101
    },
    {
        name: 'hipInternalRotation',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 102,
    },
    {
        sectionHeading: 'Hip External Rotation',
        rowNumber: 103
    },
    {
        name: 'hipExternalRotation',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 104,
    },
    {
        sectionHeading: 'Knee Flexion',
        rowNumber: 105
    },
    {
        name: 'kneeFlexion',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 106,
    },
    {
        sectionHeading: 'Knee Extension',
        rowNumber: 107
    },
    {
        name: 'kneeExtension',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 108,
    },
    {
        sectionHeading: 'Ankle Plantar Flexion',
        rowNumber: 109
    },
    {
        name: 'anklePlantarFlexion',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 110,
    },
    {
        sectionHeading: 'Ankle Dorsi Flexion',
        rowNumber: 111
    },
    {
        name: 'ankleDorsiFlexion',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 112,
    },
    {
        sectionHeading: 'Ankle Inversion',
        rowNumber: 113
    },
    {
        name: 'ankleInversion',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 114,
    },
    {
        sectionHeading: 'Ankle Eversion',
        rowNumber: 115
    },
    {
        name: 'ankleEversion',
        type: 'checkbox',
        options: [
            { label: 'LEFT AROM', value: 'LEFTAROM' },
            { label: 'LEFT PROM', value: 'LEFTPROM' },
            { label: 'LEFT MMT', value: 'LEFTMMT' },
            { label: 'LEFT TONE', value: 'LEFTTONE' },
            { label: 'RIGHT AROM', value: 'RIGHTAROM' },
            { label: 'RIGHT PROM', value: 'RIGHTPROM' },
            { label: 'RIGHT MMT', value: 'RIGHTMMT' },
            { label: 'RIGHT TONE', value: 'RIGHTTONE' }
        ],
        required: false,
        rowNumber: 116,
    },
    {
        sectionHeading: 'Limitations',
        rowNumber: 117
    },
    {
        label: 'Impairment',
        name: 'impairment',
        type: 'textarea',
        required: false,
        rowNumber: 120,
        minRows: 2,
    },
    {
        label: 'Activity/ADL Limitation',
        name: 'activityAdlLimitation',
        type: 'textarea',
        required: false,
        rowNumber: 121,
        minRows: 2,
    },
    {
        label: 'Community Participation Limitation',
        name: 'communityParticipationLimitation',
        type: 'textarea',
        required: false,
        rowNumber: 122,
        minRows: 2,
    },
    {
        sectionHeading: 'Balance',
        rowNumber: 125
    },
    {
        label: 'Sitting - Static',
        name: 'sittingStatic',
        type: 'select',
        options: [
            { label: 'Normal (N)', value: 'N' },
            { label: 'Good (G)', value: 'G' },
            { label: 'Fair (F)', value: 'F' },
            { label: 'Poor (P)', value: 'P' }
        ],
        required: false,
        rowNumber: 126,
    },
    {
        label: 'Sitting - Dynamic',
        name: 'sittingDynamic',
        type: 'select',
        options: [
            { label: 'Normal (N)', value: 'N' },
            { label: 'Good (G)', value: 'G' },
            { label: 'Fair (F)', value: 'F' },
            { label: 'Poor (P)', value: 'P' }
        ],
        required: false,
        rowNumber: 126,
    },
    {
        label: 'Standing - Static',
        name: 'standingStatic',
        type: 'select',
        options: [
            { label: 'Normal (N)', value: 'N' },
            { label: 'Good (G)', value: 'G' },
            { label: 'Fair (F)', value: 'F' },
            { label: 'Poor (P)', value: 'P' }
        ],
        required: false,
        rowNumber: 128,
    },
    {
        label: 'Standing - Dynamic',
        name: 'standingDynamic',
        type: 'select',
        options: [
            { label: 'Normal (N)', value: 'N' },
            { label: 'Good (G)', value: 'G' },
            { label: 'Fair (F)', value: 'F' },
            { label: 'Poor (P)', value: 'P' }
        ],
        required: false,
        rowNumber: 128,
    },
    {
        type: 'bulletPoint',
        bullet1: 'Normal(N) Static: Pt able to malntaln steady balance without handhold support.',
        bullet2: 'Normal(N) Dynamic: Pt accepts maximal challenge and can shift weight easily within full range.',
        rowNumber: 129
    },
    {
        type: 'bulletPoint',
        bullet1: 'Good(G) Static: Pt able to maintain balance without handhold support, limited postural sway.',
        bullet2: 'Good(G) Dynamic: Pt accepts moderate challenge; able to malntain balance whlle plcking up object off floor.',
        rowNumber: 129
    },
    {
        type: 'bulletPoint',
        bullet1: 'Fair(F) Static: Pt able to maintain balance with handhold support; may require occasional minimal assistance.',
        bullet2: 'Fair(F) Dynamic: Pt accepts minimal challenge; able to maintain balance while tuming head/trunk.',
        rowNumber: 129
    },
    {
        type: 'bulletPoint',
        bullet1: 'Poor(P) Static: Pt requires handhold support and moderate to maximal assistance to maintain position.',
        bullet2: 'Poor(P) Dynamic: Pt unable to accept challenge or move without loss of balance.',
        rowNumber: 129
    },
    {
        sectionHeading: 'Summary & Recommendations',
        rowNumber: 130
    },
    {
        label: 'Summary',
        name: 'summary',
        type: 'textarea',
        required: false,
        rowNumber: 131,
        minRows: 3,
    },
    {
        label: 'Patient Goals',
        name: 'patientGoals',
        type: 'textarea',
        required: false,
        rowNumber: 132,
        minRows: 3,
    },
    {
        sectionHeading: 'Treatment Plan Activities',
        rowNumber: 133
    },
    {
        name: 'treatmentPlanActivities',
        type: 'checkbox',
        options: [
            { label: 'Bed Mobility', value: 'Bed Mobility' },
            { label: 'Wheelchair Activities', value: 'Wheelchair Activities' },
            { label: 'Transfer Training', value: 'Transfer Training' },
            { label: 'Gait Training', value: 'Gait Training' },
            { label: 'Aquatics', value: 'Aquatics' },
            { label: 'Modalities', value: 'Modalities' },
            { label: 'Neuromuscular Re-Education', value: 'Neuromuscular Re-Education' },
            { label: 'Therapeutic Exercise', value: 'Therapeutic Exercise' },
            { label: 'Therapeutic Activities', value: 'Therapeutic Activities' },
            { label: 'Patient/Family Education', value: 'Patient/Family Education' },
            { label: 'DMB', value: 'DMB' },
            { label: 'Other', value: 'Other' },
            { label: 'Group', value: 'Group' }
        ],
        required: false,
        rowNumber: 134,
    },
    {
        label: 'Rehab Potential',
        name: 'rehabPotential',
        type: 'select',
        options: [
            { label: 'Excellent', value: 'Excellent' },
            { label: 'Good', value: 'Good' },
            { label: 'Fair', value: 'Fair' },
            { label: 'Poor', value: 'Poor' }
        ],
        required: false,
        rowNumber: 135,
    },
    {
        label: 'Next Appointment',
        name: 'nextAppt',
        type: 'date',
        required: false,
        rowNumber: 136,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date()
    },
]

export const PHYSICAL_ASSESSMENT_CONSTANT_DATA = {
    diagnosis: '',
    onset: '',
    precautions: '',
    subjective: '',
    indoorMobility: '',
    stairs: '',
    priorDeviceUse: [],
    
    gaitDeviations: '',
    movementPatterns: '',
    other: '',
    lightTouch: '',
    sharpDull: '',
    deepTouch: '',
    hotCold: '',
    kinesthesia: '',
    proprioception: '',
    
    dtr: '',
    clonus: '',
    babinski: '',
    romStatus: '',
    hipFlexion: [],
    hipExtension: [],
    hipAbduction: [],
    hipAdduction: [],
    hipInternalRotation: [],
    hipExternalRotation: [],
    kneeFlexion: [],
    kneeExtension: [],
    anklePlantarFlexion: [],
    ankleDorsiFlexion: [],
    ankleInversion: [],
    ankleEversion: [],
    
    impairment: '',
    activityAdlLimitation: '',
    communityParticipationLimitation: '',
    sittingStatic: '',
    sittingDynamic: '',
    standingStatic: '',
    standingDynamic: '',
    balanceDetails: '',
    summary: '',
    patientGoals: '',
    treatmentPlanActivities: [],
    nextAppt: '',
    rehabPotential: ''
}

// Current Level of Function Constants
export const AVAILABLE_ACTIVITIES = [
  'Roll Left and Right',
  'Sit to Lying',
  'Lying to Sitting on Side of Bed',
  'Sit to Stand',
  'Walk 10 Feet',
  'Chair/Bed to Chair Transfer',
  'Walk 50 Feet with Two Turns',
  'Car Transfer',
  'Walk 150 Feet',
  'Four Steps',
  'Twelve Steps',
  'Walk 10 Feet on Uneven Surfaces',
  'One Step Curb',
  'Picking Up Object',
  'Wheel 50 Feet with Two Turns',
  'Wheel 150 Feet',
]

export const ASSISTANCE_LEVELS = [
  '(6)-NO ASSISTANCE',
  '(5)-Helper SETS UP or CLEANS UP',
  '(4)-Helper provides VERBAL CUES or TOUCHING/STEADYING',
  '(3)-Helper does LESS THAN HALF the effort',
  '(2)-Helper does MORE THAN HALF the effort',
  '(1)-Helper does ALL of the effort',
]

export const NOT_ATTEMPTED_REASONS = [
  '(7)-Patient refused',
  '(9)-Not applicable (was not performed prior to current illness)',
  '(10)-Not attempted due to environmental limitations',
  '(88)-Not attempted due to Medical condition or safety concerns',
]

export const WHEELCHAIR_ACTIVITIES = [
  'Wheel 50 Feet with Two Turns',
  'Wheel 150 Feet',
]

